// TODO: This function should probably be deleted
export function path() {
  return window.location.pathname;
}
